<template>
    <div id="detail-client-year" :style="`color: ${theme.clientYear}`">
        <span id="client-name" v-if="clients.length">{{ clients[0].Name }}, </span><span id="year-range">{{ YearRange() }}</span>
    </div>
</template>

<script>
export default {
    name: "ProjectClientYear",
    props: {
        theme: Object,
        clients: Array,
        yearRange: Object
    },
    methods: {
        YearRange: function() {
            const { start, end } = this.yearRange;
            let range = "";
            if (start !== end) {
                range = `${start} - ${end}`;
            } else {
                range = end;
            }
            return range;
        }
    }
};
</script>